import styled, { keyframes } from "styled-components";

const faidIn = keyframes`
  0%   { opacity: 0  }
  50%  { opacity: 0.5  }
  100% { opacity: 1 }
`;

export const ReportsAndDropdownPanelContainer = styled.div`
  width: 80%;
  height: 70%;
  display: flex;
  flex-direction: column;
`;

export const ReportsPanelContainer = styled.div`
  width: 100%;
  height: 80%;
  float: left;
  text-align: center;
  background-color: #e3e3e3;
  border-radius: 2px;
  border: 1px solid white;
  box-shadow: 1px 1px 6px #d7d7d7;
  display: flex;
  flex-direction: column;
`;

export const ReportsPanelNavBar = styled.div`
  width: calc(100% - 20px);
  height: 20px;
  float: left;
  text-align: center;
  background-color: white;
  display: flex;
  padding: 10px;
  box-shadow: 0px 2px 0px #d7d7d7;
  font-weight: bold;
  color: #a9a9a9;
  font-size: 14px;
`;

export const ReportCardPanel = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
`;

export const ReportCard = styled.div`
  background-color: white;
  width: 30%;
  margin: 3% 1%;
  height: 150px;
  display: flex;
  flex-direction: column;
  opacity: 0;
  justify-content: space-between;
  box-shadow: 0px 2px 0px #d7d7d7;
  -webkit-animation: ${faidIn} 0.5s forwards;
  -moz-animation: ${faidIn} 0.5s forwards;
  -o-animation: ${faidIn} 0.5s forwards;
  animation: ${faidIn} 0.5s forwards;
`;

export const ReportCardBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: baseline;
  padding: 15px;
`;

export const ReportCardTitle = styled.label`
  font-weight: bold;
  color: #7c7c7c;
  font-size: 13px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const ReportCardFields = styled.label`
  font-weight: bold;
  color: #b6b6b6;
  font-size: 10px;
  height: 28px;
  width: 88%;
  text-align: initial;
  flex-wrap: wrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
`;

export const ReportCardDetails = styled.label`
  font-weight: bold;
  color: #b6b6b6;
  font-size: 10px;
  height: 28px;
  margin: 5px 0px;
  width: 88%;
  text-align: initial;
  flex-wrap: wrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ReportCardButton = styled.button`
  background-color: white;
  border-radius: 2px;
  border: 0px;
  border-top: 1px solid #e3e3e3;
  padding: 10px 15px;
  text-align: initial;
  color: #06ac38;
  font-weight: bold;
  outline: none;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  &:disabled {
    color: grey;
    cursor: default;
    text-decoration: none;
  }
`;

export const DescriptionButton = styled.button`
  outline: none;
  border: none;
  background-color: transparent;
  width: 20px;
  &:hover {
    cursor: pointer;
  }
`;

export const CointsContainer = styled.div`
  display: flex;
  width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: flex-end;
  }
`;

export const CointNumber = styled.div`
  width: 20px;
  height: 20px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  color: white;
  background-color: #69d389;
  border-radius: 50%;
  box-shadow: 0 0 0px 2px #fff, 0px 0px 1px 5px #69d389;
  align-items: center;
  cursor: help;
`;

export const EstimateLabel = styled.label`
  font-weight: bold;
  color: #b6b6b6;
  font-size: 10px;
  align-self: baseline;
  margin-left: 15px;
`;

export const TwoDaysContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 30px;
`;

export const DaysContainer = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: rgb(124, 124, 124);
  width: calc(50% - 50px);
`;

export const DaysInputContainer = styled.div`
  width: 100%;
`;

export const ReportCustomCardButton = styled.button`
  background-color: #06ac38;
  border-radius: 8px;
  border: 0px;
  border-top: 1px solid #e3e3e3;
  padding: 4px 6px;
  text-align: initial;
  color: white;
  font-weight: bold;
  outline: none;
  &:hover {
    cursor: pointer;
    background-color: #005a24;
  }
  &:disabled {
    color: grey;
    cursor: default;
    text-decoration: none;
  }
`;

export const CustomFieldsModal = styled.div`
  margin: 20px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  column-gap: 10px;
  padding: 20px;
`;

export const CustomFieldsModalButton = styled.button`
  background-color: #06ac38;
  border-radius: 3px;
  border: 0px;
  border-top: 1px solid #e3e3e3;
  padding: 4px 6px;
  text-align: initial;
  color: white;
  font-weight: bold;
  outline: none;
  width: calc(100% - 40px);
  text-align: center;
  margin: 15px;
  &:hover {
    cursor: pointer;
    background-color: #005a24;
  }
  &:disabled {
    color: grey;
    cursor: default;
    text-decoration: none;
    background-color: #e5e5e5;
  }
`;

export const FiltersButton = styled.button`
  outline: none;
  border: none;
  background-color: white;
  height: calc(100% - 20px);
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: rgb(6, 172, 56) !important;
  }
`;

export const ReportsCardButtonsContainer = styled.div`
  display: flex;
`;

export const FilterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FilterContainerIcon = styled.div`
  width: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: rgb(6, 172, 56) !important;
  }
`;

export const TopButtonsContainer = styled.div`
  display: flex;
  margin: 20px;
  margin-bottom: 0px;
  justify-content: space-around;
`;

export const FiltersButtonTop = styled.button`
  outline: none;
  border: none;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: rgb(6, 172, 56) !important;
  }
`;